<template>
    <div class="modal" id="modal-external-email-file" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-teal text-white font-bold">
                    Submit form to generate ICS (calendar format) file:
                </div>
                <form @submit.prevent="download()" @keydown="form.errors.clear($event.target.name)">
                    <div class="modal-body">
                        <div class="row my-2">
                            <div class="col-md-2">
                                <label :class="{'text-red' : form.errors.has('project_name')}" for="project">Contact Name</label>
                            </div>
                            <div class="col-md-4">
                                <input :class="{'border-red' : form.errors.has('project_name')}" class="form-control"
                                    type="text" v-model="form.project_name">
                                <div class="text-red text-xs" v-if="form.errors.has('project_name')">{{
                                    form.errors.get('project_name') }}
                                </div>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-2">
                                <label :class="{'text-red' : form.errors.has('subject')}" for="project">Subject</label>
                            </div>
                            <div class="col-md-4">
                                <input :class="{'border-red' : form.errors.has('subject')}" class="form-control"
                                    type="text" v-model="form.subject">
                                <div class="text-red text-xs" v-if="form.errors.has('subject')">{{
                                    form.errors.get('subject') }}
                                </div>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-2">
                                <label :class="{'text-red' : form.errors.has('description')}" for="project">Description</label>
                            </div>
                            <div class="col-md-6">
                                <textarea :class="{'border-red' : form.errors.has('description')}"
                                    class="form-control" cols="20" rows="5" v-model="form.description"></textarea>
                                <div class="text-red text-xs" v-if="form.errors.has('description')">{{
                                    form.errors.get('description') }}
                                </div>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-2">
                                <label :class="{'text-red' : form.errors.has('location')}" for="project">Location</label>
                            </div>
                            <div class="col-md-6">
                                <input :class="{'border-red' : form.errors.has('location')}"
                                    class="form-control" type="text" v-model="form.location">
                                <div class="text-red text-xs" v-if="form.errors.has('location')">{{
                                    form.errors.get('location') }}
                                </div>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-2">
                                Date/Time
                            </div>
                            <div class="col-md-6">
                                 <div class="row font-bold mb-1 ml-1">
                                     <span style="padding-right: 30%;">{{ form.day }}</span><span>{{form.day2}}</span>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="date_start">Start</label>
                                        <datetime
                                            type="time"
                                            id="date_start"
                                            name="date_start"
                                            v-model="time.start"
                                            use12-hour title="Select Start time"
                                            format="hh : mm  a"
                                            input-class="form-control bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border rounded px-2 text-grey-darkest w-full focus:outline-none">
                                        </datetime>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="date_end">End</label>
                                        <datetime
                                            id="date_end"
                                            name="date_start"
                                            type="time"
                                            use12-hour
                                            title="Select End time"
                                            format="hh : mm a"
                                            v-model="time.end"
                                            input-class="form-control bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border rounded px-2 text-grey-darkest w-full focus:outline-none"
                                        >
                                        </datetime>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-2">
                                <label :class="{'text-red' : form.errors.has('time_zone')}"
                                        for="time_zone">Time Zone:</label>

                            </div>
                            <div class="col-md-3">
                                <select name="client_profile" id="client_profile"
                                        v-model="form.time_zone"
                                        class="form-control text-sm w-full"
                                        :class="{'border-red': form.errors.has('time_zone')}">
                                    <option v-for="item in time_zone_opt" :value="item.value" :key="item.value">
                                        {{ item.name }}
                                    </option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('time_zone')">{{
                                    form.errors.get('time_zone') }}
                                </div>
                            </div>
                        </div>
                        <div class="bg-white mx-2 my-2 rounded text-grey-darkest font-bold">
                            <p> ** Click on "Add to External Email" below **</p>
                            <p> ** When prompted, click on "Open file" to add to your default calendar and accept the schedule request to insert **</p>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-link" type="reset" data-dismiss="modal">
                            Cancel
                        </button>
                        <button class="btn btn-primary">
                            Add To External Email
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../utils/form";

export default {
    name: 'contact-external-calendar-file-modal',
    props:['teamId'],
    data() {
        return {
            last_time_zone: '',
            time_zone_opt: [
                {value: 'America/New_York',     name: 'Eastern Time'},
                {value: 'America/Chicago',      name: 'Central Time'},
                {value: 'America/Denver',       name: 'Mountain Time'},
                {value: 'America/Phoenix',      name: 'Arizona Time'},
                {value: 'America/Los_Angeles',  name: 'Pacific Time'},
                {value: 'Pacific/Honolulu',     name: 'Hawaii Time'}
            ],
            time:{
                start: '',
                end: ''
            },
            form: new Form({
                project_id: '',
                project_name: '',
                subject: '',
                description: '',
                location: '',
                time: {
                    start: '',
                    end: ''
                },
                time_zone: '',
                day: '',
                day2: '',
                contact_name: '',
                contact_phone: '',
                contact_email: '',
                userTimeZoneName: null,
                userTimeZoneOffset: null,
            })
        }
    },
    created() {
        axios.get(route('external-email.last-timezone')).then(({ data }) => {
            if (data) this.last_time_zone = data;
        });

        if(this.teamId == 25) {

            this.time_zone_opt.push({value: 'Europe/London', name: 'UK Time'});
        }
    },
    methods: {
        open(sales_behavior, project) {
            $(this.$el).modal('show');
            var date = moment(sales_behavior.date);
            if(sales_behavior.end_date !== null){
                var endDate = moment(sales_behavior.end_date);
            }else{
                var endDate = moment(sales_behavior.date).add('minute', 30);
            }

            this.time.start = date.toISOString();
            this.time.end   = endDate.toISOString();

            this.form.project_id   = project.id;
            this.form.location     = project.location;
            this.form.project_name = project.name;
            this.form.subject      = sales_behavior.name;
            this.form.description  = sales_behavior.name;
            this.form.day          = moment(this.time.start).utc().format('MM/D/Y');
            this.form.day2          = moment(this.time.end).utc().format('MM/D/Y');
            this.form.time_zone    = this.last_time_zone ? this.last_time_zone : '';
            this.form.contact_name = project.contact.name;
            this.form.contact_phone = project.contact.phone || project.contact.cell;
            this.form.contact_email = project.contact.email;
        },
        download(){
            this.form.time.start    = moment(this.time.start).utc(1).format("YYYY-MM-DD HH:mm");
            this.form.time.end      = moment(this.time.end  ).utc(1).format("YYYY-MM-DD HH:mm");
            this.form.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.form.userTimeZoneOffset = new Date().getTimezoneOffset();

            this.form.post(route('external-email.file-download'))
                .then((data) => {
                    this.last_time_zone = this.form.time_zone;
                    window.location = data;
                });
        }
    }
}
</script>

<style lang="css">
    .vdatetime-time-picker__item--selected{
        color: #01b1af !important;
    }
    .vdatetime-popup__actions__button{
        color: #01b1af !important;
    }
    .vdatetime-popup__header{
        background: #01b1af !important;
    }
</style>
